import { baseUrl } from "../const/base-url";

export type Category = {
  _id: string;
  name: string;
};

export async function fetchCategories(): Promise<Category[]> {
  const res = await fetch(baseUrl + "/api/categoriesoffline");

  if (!res.ok) {
    throw new Error("Ошибка загрузки категорий");
  }

  return res.json();
}
